/* eslint-disable react-hooks/exhaustive-deps */
import TarjetaViaje from "./TarjetaViaje";
import React, { useCallback, useEffect, useState } from "react";
import { useSeguimientoMonitoreo } from "./SeguimientoMonitoreoProvider";
import { useIndicadores } from "./indicadores/IndicadoresProvider";
import { nombreColorIndicador, tipoIndicador } from "./SeguimentoConstantes";
import constantes from "../../constantes";

const TarjetasViaje = ({ handleTooltip, onHideTooltip, soloUnidades }) => {
  const {
    viajes,
    filtro,
    viajesFiltrados,
    onSetLocalFilter,
    mostrarOcultar,
    viajeVisible,
    centrarUnidad,
    esSeguimientoMonitoreo,
    seleccionarViaje,
  } = useSeguimientoMonitoreo();

  const { overlayOnClick, viajeRutaId } = useIndicadores();

  const { texto, indicadorId, colorId, colorIds } = filtro.value;

  const aplicarFiltroLocal = () => {
    const cartaPorte = parseInt(texto);
    const filtroTexto = texto.toLowerCase().trim();
    let filtrados =
      texto.length > 0
        ? viajes.filter(
            (e) =>
              e.caja?.toLowerCase()?.includes(filtroTexto) ||
              e.unidad?.toLowerCase()?.includes(filtroTexto) ||
              e.cliente?.toLowerCase()?.includes(filtroTexto) ||
              e.operador?.toLowerCase()?.includes(filtroTexto) ||
              e.ruta?.toLowerCase()?.includes(filtroTexto) ||
              e.subCliente?.toLowerCase()?.includes(filtroTexto) ||
              (!isNaN(cartaPorte) && e.cartaPorte === cartaPorte) ||
              e.idViaje === filtroTexto ||
              e.idViajeRetorno === filtroTexto,
          )
        : viajes;

const coloresSeleccionados = Array.isArray(colorIds)
    ? colorIds
    : colorId != null
        ? [colorId] 
        : [];

if (indicadorId != null && coloresSeleccionados.length > 0) {
    filtrados = indicadorId < 99
        ? filtrados.filter(e =>
            e.indicadores != null &&
            coloresSeleccionados.includes(
                e.indicadores[indicadorId]?.color
            )
        )
        : filtrados.filter(e =>
            coloresSeleccionados.includes(e.color)
        );
}
    onSetLocalFilter(filtrados);
  };
  useEffect(() => {
    aplicarFiltroLocal();
  }, [viajes]);

  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (timer != null) clearTimeout(timer);
    setTimer(setTimeout(aplicarFiltroLocal, 500));
  }, [texto]);

useEffect(() => {
    aplicarFiltroLocal();
}, [indicadorId, colorId, colorIds]);

  const getViaje = useCallback(
    (viajeId) => {
      return (
        viajesFiltrados.find((v) => String(v.viajeId) === String(viajeId)) || {}
      );
    },
    [viajesFiltrados],
  );

  const getBotonPanicoCss = useCallback((viajeId) => {
    const viaje = getViaje(viajeId);
    if (viaje?.indicadores == null) return "";
    const indicador =
      viaje.indicadores[
        esSeguimientoMonitoreo
          ? tipoIndicador.seguimiento
          : tipoIndicador.botonPanico
      ];
    return indicador?.color === nombreColorIndicador.rojo ? "boton-panico" : "";
  }, []);

  const getAlertaPenskeCss = useCallback(
    (viajeId) => {
      const viaje = getViaje(viajeId);
      if (!viaje) return "";

      const esClientePenske = viaje?.cliente === constantes.cliente.Penske;
      const requiereSeguimiento = viaje.ultimosIndicadores?.some(
        (i) => i.indicador === 15 && i.color === 3 && i.atendido !== true,
      );

      return esClientePenske && requiereSeguimiento ? "boton-penske" : "";
    },
    [getViaje],
  );

  const getAlertaConduccionCss = useCallback(
    (viajeId) => {
      const viaje = getViaje(viajeId);
      if (!viaje) return "";
      const requiereSeguimiento = viaje.ultimosIndicadores?.some(
        (i) => i.indicador === 17 && i.atendido !== true,
      );

      return requiereSeguimiento ? "boton-conduccion" : "";
    },
    [getViaje],
  );
  const getAlertaRescateCss = useCallback(
    (viajeId) => {
      const viaje = getViaje(viajeId);
      if (!viaje) return "";
      const requiereSeguimiento = viaje.ultimosIndicadores?.some(
        (i) => i.indicador === 15 && i.color === 7 && i.atendido !== true,
      );

      return requiereSeguimiento ? "boton-rescate" : "";
    },
    [getViaje],
  );
  const handleSeleccionar = useCallback(
    (viajeId) => {
      const viaje = getViaje(viajeId);
      seleccionarViaje(viaje);
    },
    [getViaje],
  );

  const handleOverlayOnClick = useCallback(
    (event, type, viajeId) => {
      const viaje = getViaje(viajeId);
      overlayOnClick(event, type, viaje);
    },
    [overlayOnClick, getViaje],
  );

  const onShowTooltip = useCallback(
    (event, tipo, viajeId) => {
      handleTooltip(event, tipo, viajeId);
    },
    [handleTooltip],
  );

  return (
    <div className={"seg-viajes"}>
      {viajesFiltrados &&
        viajesFiltrados.map((viaje) => (
          <TarjetaViaje
            key={`${viaje.viajeId}-${viaje.unidadId}`}
            onTooltipIndicador={onShowTooltip}
            onHideTooltip={onHideTooltip}
            soloUnidades={soloUnidades}
            mostrarOcultar={mostrarOcultar}
            viajeVisible={viajeVisible}
            centrarUnidad={centrarUnidad}
            esSeguimientoMonitoreo={esSeguimientoMonitoreo}
            seleccionarViaje={handleSeleccionar}
            overlayOnClick={handleOverlayOnClick}
            viajeRutaId={viajeRutaId}
            viajeId={viaje.viajeId}
            unidadId={viaje.unidadId}
            cajaId={viaje.cajaId}
            unidad={viaje.unidad}
            caja={viaje.caja}
            cliente={viaje.cliente}
            subCliente={viaje.subCliente}
            ruta={viaje.ruta}
            cartaPorte={viaje.cartaPorte}
            esExpeditado={viaje.esExpeditado}
            color={viaje.color}
            operador={viaje.operador}
            indicadores={viaje.indicadores}
            getBotonPanicoCss={getBotonPanicoCss}
            getAlertaPenskeCss={getAlertaPenskeCss}
            getAlertaRescateCss={getAlertaRescateCss}
            getAlertaConduccionCss={getAlertaConduccionCss}
            tieneMantenimiento={viaje.tieneMantenimiento}
            nuevoIngreso={viaje.nuevoIngreso}
            estatus={viaje.estatus}
          />
        ))}
    </div>
  );
};
export default TarjetasViaje;
